import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import Auth from './Auth';
import Inscription from './Inscription';
import Tampon from './Tampon';
import Affiche from './Affiche';
import Legal from './Legal';
import Landing from './Landing';
import Preferences from './Preferences';
import { supabase } from './supabase';
import reportWebVitals from './reportWebVitals';

// Pages réservées au commerçant connecté : affiche l'écran de connexion sinon
function Protege({ children }) {
  const [session, setSession] = useState(undefined)
  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => setSession(data.session))
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_e, s) => setSession(s))
    return () => subscription.unsubscribe()
  }, [])
  if (session === undefined) return null
  if (!session) return <Auth />
  return children(session)
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/c/:commerceId" element={<Inscription />} />
        <Route path="/t/:clientId" element={<Protege>{s => <Tampon session={s} />}</Protege>} />
        <Route path="/affiche" element={<Protege>{s => <Affiche session={s} />}</Protege>} />
        <Route path="/p/:jeton" element={<Preferences />} />
        <Route path="/legal/:page" element={<Legal />} />
        <Route path="/app" element={<App />} />
        <Route path="/demo" element={<App demo />} />
        <Route path="*" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
